import * as yup from 'yup';

import type { TFunction } from 'i18next';

const commentTemplateSchema = (t: TFunction) => yup.object().shape({
    title: yup.string().required(t('REQUIRED')),
    note: yup.string().required(t('REQUIRED')),
});

export default commentTemplateSchema;
